import React from 'react';
import { connect } from 'tanok';
import { t } from 'c-3po';
import { toJS } from '../../helpers/ImmutableToJS';
import * as a from './../../../libs/actions';

import { Button } from '../../ui/button';

// styles
import css from './client.sss';


class UnbanView extends React.Component {

    handleClientUnblock = () => {
        this.props.send(a.EVENT_BESIDA_SEND_UNBAN_LIST);
    }

    render() {
        return (
            <div className={css.unban}>
                <div className={css.unbanText}>
                    {t`Покупатель заблокирован`}
                </div>
                <Button
                    onClick={this.handleClientUnblock}
                >
                    {t`Разблокировать`}
                </Button>
            </div>
        );
    }
}

export const Unban = connect()(toJS(UnbanView));
